import type { AnimationConfig } from './types';

export const desktopAnimationTriggerPoints: AnimationConfig = {
  target: 'desktop',
};

export const mobileAnimationTriggerPoints: AnimationConfig = {
  target: 'mobile',
};
